import { Fragment } from "react";
import { RaceLink, RaceLinkData } from "../npc/RaceLink";

export function QuestRaceList(props: { races: RaceLinkData[] }) {
  return (
    <>
      {props.races.map((race, i) => (
        <Fragment key={i}>
          {i > 0 && ", "}
          <RaceLink race={race} />
        </Fragment>
      ))}
    </>
  );
}
